import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  templateUrl: "./legal.component.html",
  styleUrls: ["./legal.component.scss"],
})
export class LegalComponent implements OnInit {
  activeTab = "Cancellation Policy";
  isMobileDevice = false;

  constructor(private _activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    window.matchMedia("(max-width: 1000px)").matches
      ? (this.isMobileDevice = true)
      : (this.isMobileDevice = false);

    const tabFromRout = this._activatedRoute.snapshot.params["tab"];
    if (tabFromRout) {
      this.activeTab = tabFromRout.replaceAll("_", " ");
    }
  }

  selectTable(val: string) {
    if (this.isMobileDevice) {
      if (this.activeTab === val) {
        this.activeTab = "";
      } else {
        this.activeTab = val;
      }

      return false;
    }

    this.activeTab = val;
  }
}
